import { hostApi } from "@/apis/index";
import Vue from 'vue';

const api_faq = `${hostApi}/api/app/faqs`;

function getFaqList(params) {
    return Vue.prototype.$http.get(api_faq, { params });
}

function getFaq(id) {
    return Vue.prototype.$http.get(`${api_faq}/${id}`);
}

export {
    getFaqList,
    getFaq,
};
